import * as React from 'react';
import { withStyles, Theme, WithStyles, createStyles } from '@material-ui/core';
import Tabs, { TabsProps } from 'ha/ui/next/Tabs';
import units from 'ha/theme/units';

export const styles = (t: Theme) =>
  createStyles({
    root: {
      display: 'inline-block',
      minHeight: 'initial',
      borderRadius: units.rem(2),
      backgroundColor: t.palette.grey[50],
    },
    indicator: {
      display: 'flex',
      height: '100%',
      background: 'transparent',
      padding: units.rem(0.5),
    },
    toggle: {
      flex: 1,
      boxShadow: 'rgba(0, 0, 0, 0.11) 0px 2px 9px 0px',
      borderRadius: units.rem(2),
      backgroundColor: t.palette.white.main,
    },
  });

type Props = TabsProps & WithStyles<typeof styles>;

export const StyledTabs: React.SFC<Props> = props => (
  <Tabs
    {...props}
    TabIndicatorProps={{
      children: <div className={props.classes.toggle} />,
    }}
  />
);

export default withStyles(styles)(StyledTabs);
